import { SearchspringFetcher } from '../classes/searchspring-fetcher'

import { generateSearchspringProvider } from './provider'

export class SearchspringSuggest extends SearchspringFetcher {
  generateURL() {
    const endpoint = '/api/suggest/query'
    return super.generateURL(endpoint)
  }

  updateParams(options = {}) {
    const { query } = options

    this.params.set('language', 'en')
    this.params.set('suggestionCount', 4)
    this.params.set('productCount', 5)

    if (query) this.params.set('q', query)

    super.updateParams()
  }
}

export const SearchspringSuggestProvider = generateSearchspringProvider(SearchspringSuggest, (results) => {
  return results
})
